export default {
  error_messages: {
    orders_disabled: 'Bestilling her er ikke mulig i øjeblikket',
  },
};
